import { render, staticRenderFns } from "./BgSelector.vue?vue&type=template&id=2ed82697&scoped=true&"
import script from "./BgSelector.vue?vue&type=script&lang=js&"
export * from "./BgSelector.vue?vue&type=script&lang=js&"
import style0 from "./BgSelector.vue?vue&type=style&index=0&id=2ed82697&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed82697",
  null
  
)

export default component.exports